import styled, { css } from 'styled-components';

/**
 * Wrapper that hosts the lib `<Breadcrumb>` and a capturing keydown
 * listener so power users can press F2 on the focused current segment
 * to enter rename mode (matches the file-explorer / spreadsheet
 * convention). `min-width: 0` so the breadcrumb can shrink-to-fit
 * inside the topbar's flex layout.
 */
export const CrumbsHost = styled.div`
  display: flex;
  min-width: 0;
`;

/**
 * Inline rename input used in the current crumb's `render` slot. Styled
 * to land in the exact footprint of the static crumb (matching font
 * size / weight / padding / radius so the topbar doesn't reflow when
 * the user enters rename mode) and gets a primary-tinted border + glow
 * so it reads as the active edit target.
 *
 * Kept local to the editor breadcrumb because the primary glow is more
 * pronounced than any of the @aibuild/ui `TextField` appearances; once
 * a closer-matching shared appearance ships, this can collapse onto it.
 */
export const CrumbRenameInput = styled.input`
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  width: 240px;
  max-width: 360px;
  min-width: 120px;
  padding: 4px 6px;
  border-radius: 6px;
  outline: none;
  ${({ theme: { colors = {} } }) => css`
    background: ${colors.surfaceContainerHigh ?? 'rgba(255, 255, 255, 0.08)'};
    color: ${colors.onSurface ?? '#E6E6F2'};
    border: 1px solid ${colors.primary ?? '#C1C1FF'};
    box-shadow: 0 0 0 2px
      color-mix(in oklch, ${colors.primary ?? '#C1C1FF'} 25%, transparent);
  `}
`;
